<template>
  <div class="doc-card">
    <div class="doc-card__header">
      <span class="doc-card__icon">📄</span>
      <span class="doc-card__name">{{ document.document_name }}</span>
      <button v-if="editable" class="doc-card__remove" @click="handleDelete" :disabled="isDeleting">
        {{ isDeleting ? '…' : 'Entfernen' }}
      </button>
    </div>

    <div v-if="document.category_caseworker" class="doc-card__row">
      <span>Vom Sachbearbeiter geprüft:</span>
      <strong>{{ categoryLabel(document.category_caseworker) }}</strong>
    </div>

    <p v-if="errorMessage" class="doc-card__error">⚠ {{ errorMessage }}</p>
  </div>
</template>

<script>
import { ref } from 'vue';
import { caseApi } from '../services/caseApi.js';

export default {
  name: 'CaseDocumentCard',
  props: {
    document: { type: Object, required: true },
    categories: { type: Array, required: true },
    clientId: { type: String, required: true },
    caseId: { type: String, required: true },
    // Category is fixed at upload time - the remove action is the only edit
    // available here, and only while the citizen has explicitly opted into
    // edit mode (see ApplicationViewC's isEditMode).
    editable: { type: Boolean, default: false },
  },
  emits: ['deleted'],

  setup(props, { emit }) {
    const isDeleting = ref(false);
    const errorMessage = ref(null);

    const categoryLabel = (value) => {
      const match = props.categories.find((c) => c.id === value);
      return match ? match.label : value;
    };

    const handleDelete = async () => {
      isDeleting.value = true;
      errorMessage.value = null;
      try {
        await caseApi.deleteDocument(props.clientId, props.caseId, props.document.document_id);
        emit('deleted', props.document.document_id);
      } catch (e) {
        errorMessage.value = e.message || 'Entfernen fehlgeschlagen.';
        isDeleting.value = false;
      }
    };

    return { isDeleting, errorMessage, categoryLabel, handleDelete };
  },
};
</script>

<style scoped>
.doc-card {
  background: #fff;
  border-radius: 8px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}
.doc-card__header { display: flex; align-items: center; gap: 8px; min-width: 0; }
.doc-card__icon { font-size: 15px; flex-shrink: 0; }
.doc-card__name {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 700;
  color: #1a1a2e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.doc-card__remove {
  flex-shrink: 0;
  background: none;
  border: none;
  color: #6b7280;
  font-size: 11px;
  cursor: pointer;
  text-decoration: underline;
}
.doc-card__row { font-size: 12px; color: #374151; display: flex; gap: 6px; }
.doc-card__row span { color: #9ca3af; }
.doc-card__pending { font-style: italic; color: #9ca3af; }
.doc-card__error { font-size: 11px; color: #dc2626; }
</style>
